/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var trigger_category_changes = document.querySelectorAll('.js-category');
  if(trigger_category_changes) {
    trigger_category_changes.forEach((trigger_category_change) => {
      trigger_category_change.addEventListener('change', (e) => {
        e.preventDefault();

        var category_base = trigger_category_change.getAttribute('data-category-base');

        if(category_base === '') {
          category_base = 'category';
        }

        var suffix = '';
        if(trigger_category_change.hasAttribute('data-url-suffix')) {
          suffix = trigger_category_change.getAttribute('data-url-suffix');
        }

        if(trigger_category_change.querySelector('select').value === '0') {
          location.href = trigger_category_change.getAttribute('data-url-prefix') + (suffix);

          return;
        }

        location.href = trigger_category_change.getAttribute('data-url-prefix') + '/' + category_base + '/' + trigger_category_change.querySelector('select').value + (suffix);
      });
    });
  }
}());